<template>
  <div class="pathology">
    <img src="@/assets/img/icons.svg#icon-pathology" width="16" height="16">
    Pathologie&nbsp;: {{pathology}}
  </div>
</template>

<script>

  export default {
    name: "Pathology",
    props: ['pathology', 'theme']
  }
</script>

<style lang="scss">
  .pathology {
    font-size: rem(14px);
    line-height: rem(18px);
    color: color(grey-dark);
    font-weight: 700;
    display: flex;
    align-items: center;

    img {
      margin-right: rem(5px);
    }
  }
</style>